module.exports = __webpack_public_path__ + "img/rs_logo.178a0e04.png";